// @flow

import React, { Component } from "react";
import { compose } from "react-apollo";
import _ from "lodash";

import {
  Form,
  FormControl,
  FormGroup,
  Col,
  ControlLabel,
  Button
} from "react-bootstrap";

import type { UserProfile } from "../../data/accounts";

import { withUser } from "../../data/accounts";
import { withNetworkUserInfo } from "../../data/accounts";
// Project-based functionality disabled as users are no longer prompted for demographic info mid-project.
// import { withRetrieveProject } from "../../data/project";
import LikertForm from "../LikertForm/LikertForm";
import countries from "./countries.js";
import withLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import "./UserProfileForm.css";

type State = UserProfile;
type Props = Object;
// type Props = {
//   onSubmit: UserProfile => void,
//   submitButtonLabel: string,
// } & userInfoQueryResult;

class UserProfileForm extends Component<Props, State> {
  labelSm = 2;
  formSm = 7;

  constructor(props: Props) {
    super(props);
    this.state = props.profileData.user;
  }

  handleLikertChange = (name: string, value: number) => {
    this.setState({ [name]: value });
  };

  likert(name: string, label: string, value?: number) {
    return (
      <LikertForm
        name={name}
        value={value}
        label={label}
        onChange={value => this.handleLikertChange(name, value)}
        sm={this.labelSm + this.formSm}
      />
    );
  }

  canBeSubmitted() {
    const optionalFields = ["satMath"];
    const fermiRequired = ["fermiSkill"];
    const politifactRequired = [
      "party",
      "politicsKnowledgeUS",
      "newspaperVolume"
    ];

    const projectTemplate = this.projectTemplate();
    if (projectTemplate !== "fermi") {
      optionalFields.push(...fermiRequired);
    }
    if (projectTemplate !== "politifact") {
      optionalFields.push(...politifactRequired);
    }

    let allReady = true;
    Object.entries(this.state).forEach(([key, value]) => {
      if (!value && !_.includes(optionalFields, key)) {
        allReady = false;
      }
    });
    return allReady;
  }

  projectTemplate() {
    if (!this.props.projectData || !this.props.projectData.Project) {
      return null;
    }
    const template = this.props.projectData.Project.template;
    return template;
  }

  projectQuestions() {
    const projectTemplate = this.projectTemplate();
    if (projectTemplate === "fermi") {
      return (
        <div>
          {this.likert(
            "fermiSkill",
            "Skill at Fermi questions:",
            this.state.fermiSkill
          )}
        </div>
      );
    } else if (projectTemplate === "politifact") {
      return (
        <div>
          {this.likert(
            "politicsKnowledgeUS",
            "Knowledge of American politics:",
            this.state.politicsKnowledgeUS
          )}
          {this.likert(
            "newspaperVolume",
            "Newspaper reading amount:",
            this.state.newspaperVolume
          )}
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const submitEnabled = this.canBeSubmitted();
    return (
      <div>
        <p>{this.props.subtitleText}</p>
        <Form
          horizontal
          action=""
          onSubmit={event => {
            this.props.onSubmit(this.state);
            event.preventDefault();
          }}
        >
          <FormGroup controlId="formHorizontalAge">
            <Col componentClass={ControlLabel} sm={this.labelSm}>
              Age in years
            </Col>
            <Col sm={this.formSm}>
              <FormControl
                type="number"
                value={this.state.age || ""}
                onChange={e =>
                  this.setState({ age: parseInt(e.target.value, 10) })
                }
              />
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalCountry">
            <Col componentClass={ControlLabel} sm={this.labelSm}>
              Country
            </Col>

            <Col sm={this.formSm}>
              <FormControl
                type="string"
                componentClass="select"
                value={this.state.country || ""}
                onChange={e => this.setState({ country: e.target.value })}
              >
                <option value="empty" />
                <option value="United States">United States</option>
                {countries.map(country => (
                  <option value={country} key={country}>
                    {country}
                  </option>
                ))}
                <option value="Other">Other</option>
              </FormControl>
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalEducation">
            <Col componentClass={ControlLabel} sm={this.labelSm}>
              Education
            </Col>

            <Col sm={this.formSm}>
              <FormControl
                type="string"
                componentClass="select"
                value={this.state.education || ""}
                onChange={e => this.setState({ education: e.target.value })}
              >
                <option value="empty" />
                <option value="High School">High School</option>
                <option value="Associates">Associates</option>
                <option value="Bachelors">Bachelors</option>
                <option value="Masters">Masters</option>
                <option value="PhD">PhD</option>
              </FormControl>
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalOccupation">
            <Col componentClass={ControlLabel} sm={this.labelSm}>
              Occupation
            </Col>
            <Col sm={this.formSm}>
              <FormControl
                type="text"
                placeholder="Occupation"
                value={this.state.occupation || ""}
                onChange={e => this.setState({ occupation: e.target.value })}
              />
            </Col>
          </FormGroup>

          {this.projectTemplate() === "politifact" ? (
            <FormGroup controlId="formHorizontalParty">
              <Col componentClass={ControlLabel} sm={this.labelSm}>
                Political Party
              </Col>
              <Col sm={this.formSm}>
                <FormControl
                  type="string"
                  componentClass="select"
                  value={this.state.party || ""}
                  onChange={e => this.setState({ party: e.target.value })}
                >
                  <option value="empty" />
                  <option value="Democrat">Democrat</option>
                  <option value="Republican">Republican</option>
                  <option value="Independent">Independent</option>
                  <option value="None of the above">None of the above</option>
                  <option value="Prefer not to answer">
                    Prefer not to answer
                  </option>
                </FormControl>
              </Col>
            </FormGroup>
          ) : null}

          <FormGroup controlId="formSatMath">
            <Col sm={this.labelSm + this.formSm}>
              <ControlLabel>SAT Math Score 200-800 (optional)</ControlLabel>
              <FormControl
                type="text"
                value={this.state.satMath || ""}
                onChange={e =>
                  this.setState({ satMath: parseInt(e.target.value, 10) })
                }
              />
            </Col>
          </FormGroup>

          {this.likert(
            "arithmetic",
            "Skill at mental arithmetic (e.g. multiplying two-digit numbers):",
            this.state.arithmetic
          )}
          {this.likert(
            "sports",
            "General knowledge of US sports:",
            this.state.sports
          )}
          {this.likert(
            "science",
            "General knowledge of science:",
            this.state.science
          )}
          {this.likert(
            "geography",
            "General knowledge of geography:",
            this.state.geography
          )}
          {this.projectQuestions()}

          <FormGroup>
            <Col sm={this.labelSm + this.formSm} className="SignUpForm-Submit">
              <Button bsStyle="success" type="submit" disabled={!submitEnabled}>
                {this.props.submitButtonLabel}
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

const extendComponent = compose(
  withNetworkUserInfo,
  // withRetrieveProject,
  withUser,
  withLoadingIndicator
);

export default extendComponent(UserProfileForm);



// WEBPACK FOOTER //
// ./src/components/UserProfileForm/UserProfileForm.js